import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-police-prevention',
  templateUrl: './privacy-police-prevention.component.html',
  styleUrls: ['./privacy-police-prevention.component.scss']
})
export class PrivacyPolicePreventionComponent {}
